import { render, staticRenderFns } from "./ResidentProfilesForm.vue?vue&type=template&id=be7815da&"
import script from "./ResidentProfilesForm.vue?vue&type=script&lang=js&"
export * from "./ResidentProfilesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports